import Vue from 'vue'
import { VBToggle, VBTooltip, VBPopover } from 'bootstrap-vue'

Vue.directive('RkmToggle', VBToggle)
Vue.directive('RkmTooltip', VBTooltip)
Vue.directive('RkmPopover', VBPopover)

import alpha from './directives/alpha'
import alphaSpace from './directives/alphaSpace'
import number from './directives/number'
import trim from './directives/trim'
import uppercase from './directives/uppercase'

Vue.directive('alpha', alpha)
Vue.directive('alpha-space', alphaSpace)
Vue.directive('number', number)
Vue.directive('trim', trim)
Vue.directive('uppercase', uppercase)